import { Outlet } from "react-router-dom";
import { Logout } from "../Component/Home/Logout";
import { MenuBar } from "../Component/Home/MenuBar";
import Footer from '../Component/Footer';

export function Layout() {

    return (
        <div>
            <div className="supplier-details-container">
                <Logout/>
            </div>
            <Outlet />
             <MenuBar />
            <Footer />
        </div>
    );
}